import { getBaseUrl } from '@repo/common-utils/utils/url'
import { get, ENCRYPT_TYPES } from '@repo/http/http'

const { VUE_APP_UC = '' } = import.meta.env
const baseUrl = getBaseUrl(VUE_APP_UC)

/** 与 pay 项目 AreaCodeList 接口字段一致 */
export interface AreaCodeItem {
  zhCn: string
  zhTw: string
  en: string
  areaCode: string
  countryCode: string
  countryCode2?: string
  initial?: string
}

export const FALLBACK_AREA_CODES: AreaCodeItem[] = [
  { zhCn: '中国大陆', zhTw: '中國大陸', en: 'China', areaCode: '+86', countryCode: 'CHN', countryCode2: 'CN', initial: 'Z' },
  { zhCn: '中国香港', zhTw: '中國香港', en: 'Hong Kong', areaCode: '+852', countryCode: 'HKG', countryCode2: 'HK', initial: 'Z' },
  { zhCn: '中国澳门', zhTw: '中國澳門', en: 'Macau', areaCode: '+853', countryCode: 'MAC', countryCode2: 'MO', initial: 'Z' },
  { zhCn: '中国台湾', zhTw: '中國台灣', en: 'Taiwan', areaCode: '+886', countryCode: 'TWN', countryCode2: 'TW', initial: 'Z' },
]

let cachedList: AreaCodeItem[] | null = null
let loadingPromise: Promise<AreaCodeItem[]> | null = null

function parseAreaCodeListResponse(res: unknown): AreaCodeItem[] | null {
  if (Array.isArray(res)) return res as AreaCodeItem[]

  if (res && typeof res === 'object') {
    const payload = res as Record<string, unknown>
    if (Array.isArray(payload.result)) return payload.result as AreaCodeItem[]

    const data = payload.data
    if (Array.isArray(data)) return data as AreaCodeItem[]
    if (data && typeof data === 'object') {
      const nested = data as Record<string, unknown>
      if (Array.isArray(nested.result)) return nested.result as AreaCodeItem[]
    }
  }

  return null
}

/** 参考 pay `/uc/v1/AreaCodeList` 拉取区号列表，失败时回退常用区号 */
async function fetchAreaCodeList(): Promise<AreaCodeItem[]> {
  try {
    const res = await get(`${baseUrl}/uc/v1/AreaCodeList?`, {
      params: {},
      jsBridge: false,
      encrypt: ENCRYPT_TYPES.NO_ENCRYPT,
      noEncTag: true,
    })

    const list = parseAreaCodeListResponse(res)
    if (list?.length) {
      return list
    }
  } catch {
    /* 接口不可用时使用本地兜底 */
  }
  return FALLBACK_AREA_CODES
}

/** 获取区号列表（模块级缓存，避免重复请求） */
export function getAreaCodeList(): Promise<AreaCodeItem[]> {
  if (cachedList) {
    return Promise.resolve(cachedList)
  }
  if (!loadingPromise) {
    loadingPromise = fetchAreaCodeList().then((list) => {
      cachedList = list.length ? list : FALLBACK_AREA_CODES
      return cachedList
    })
  }
  return loadingPromise
}
